'use client';

import { createContext, useRef } from 'react';

export const PageStateContext = createContext(null);

function PageStateProvider({ children }) {
    /* dynamic pages */
    const communityDetailsPages = useRef({});
    const contentProviderPages = useRef({});
    const recentUserSubmissions = useRef({});
    /* static pages */
    const timeline = useRef({});
    const quizzesPage = useRef({});
    const profilePage = useRef({});
    const communitiesListPage = useRef({});
    const coinedVideosListPage = useRef({});
    const communityPage = useRef({});

    return (
        <PageStateContext.Provider
            value={{
                contentProviderPages,
                timeline,
                quizzesPage,
                profilePage,
                communitiesListPage,
                coinedVideosListPage,
                communityPage,
                communityDetailsPages,
                recentUserSubmissions
            }}>
            {children}
        </PageStateContext.Provider>
    );
}

export default PageStateProvider;
